import { Delete } from "@mui/icons-material";
import { Card, CardContent, 
    Typography, Box, IconButton,
    CardMedia} from "@mui/material";
import { DropzoneState } from "react-dropzone/.";


export interface IImageUpload {
    imageState: DropzoneState;
    activeThumbnail: (() => string | null);
    onDelete: (() => void);

}

export const ImageUploadBox = ({ imageState, activeThumbnail, onDelete }: IImageUpload) => {
    return (
        <Card elevation={0} sx={{ width: "100%", marginTop: 2, boxShadow: 0 }}>
            <CardContent>
                <Typography variant="h6" gutterBottom>
                    Sale Item Thumbnail
                </Typography>

                <Box
                    {...imageState.getRootProps()}
                    sx={{
                        border: "2px dashed #cccccc",
                        borderRadius: "5px",
                        padding: 2,
                        marginTop: 2,
                        textAlign: "center",
                        backgroundColor: "#fafafa",
                    }}
                >
                    <input {...imageState.getInputProps()} />
                    <Typography variant="body1">
                        Drag and drop your thumbnail here, or click to select files
                    </Typography>
                </Box>

                <Box sx={{ marginTop: 2 }}>
                    {activeThumbnail() && (
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                padding: 1,
                                border: "1px solid #cccccc",
                                borderRadius: "5px",
                                marginBottom: 1,
                                backgroundColor: "#ffffff",
                            }}
                        >
                            <CardMedia
                                component="img"
                                height="140"
                                image={activeThumbnail()!}
                                alt="Sale Item Thumbnail"
                            />
                            <IconButton
                                aria-label="Remove file"
                                size="small"
                                onClick={() => {
                                }}
                                sx={{
                                    color: "#ff4d4d",
                                    "&:hover": { color: "#ff0000" },
                                }}
                            >
                                <Delete />
                            </IconButton>
                        </Box>
                    )}
                </Box>
            </CardContent>
        </Card>
    );
};